import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
  closeLabel?: string;
};

export function AtlanteDialog({
  open,
  title,
  message,
  onClose,
  closeLabel,
}: Props) {
  const { t } = useTranslation();

  const resolvedTitle =
    title ?? t("onboarding.common.temporaryIssue.title", "Temporary issue");

  const resolvedCloseLabel =
    closeLabel ?? t("onboarding.common.temporaryIssue.ok", "OK");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "24px",
          p: 0,
          overflow: "hidden",
          border: "1px solid #E4EDF5",
          boxShadow: "0 20px 60px rgba(15, 23, 42, 0.18)",
          minWidth: { xs: "auto", sm: 420 },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1.25 }}>
        <Box
          sx={{
            height: 6,
            width: "100%",
            borderRadius: 999,
            background: "linear-gradient(90deg, #6CCB8B 0%, #3975D0 100%)",
            mb: 2,
          }}
        />
        <Typography sx={{ fontWeight: 800, color: "#0A0A0A" }}>
          {resolvedTitle}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 2.5 }}>
        <Typography sx={{ color: "#4A5568", lineHeight: 1.55 }}>
          {message}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              px: 4,
              py: 1.1,
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 700,
              background: "linear-gradient(90deg, #6CCB8B 0%, #3975D0 100%)",
            }}
          >
            {resolvedCloseLabel}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
